(function () {
  if (window.__faqSchemaInjected) return;

  // ---------- Helpers ----------

  // Recursively checks whether JSON-LD data contains a specific @type.
  // Supports single objects, top-level arrays, nested @graph, and @type arrays.
  function containsType(data, type) {
    if (!data) return false;

    if (Array.isArray(data)) {
      return data.some(item => containsType(item, type));
    }

    if (typeof data === 'object') {
      const t = data['@type'];

      if (t === type) return true;
      if (Array.isArray(t) && t.includes(type)) return true;
      if (data['@graph']) return containsType(data['@graph'], type);
    }

    return false;
  }

  function alreadyHasFaqSchema() {
    const nodes = document.querySelectorAll('script[type="application/ld+json"]');

    for (const s of nodes) {
      try {
        if (containsType(JSON.parse(s.textContent), 'FAQPage')) return true;
      } catch (e) {
        // Ignore invalid JSON-LD.
      }
    }

    return false;
  }

  // Gets text content and normalizes whitespace.
  function getText(el) {
    if (!el) return '';
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  // Creates a normalized key for duplicate-question checks.
  function dedupKey(q) {
    return q.toLowerCase().replace(/\s+/g, ' ').trim();
  }

  // ---------- Main ----------

  function init() {
    if (window.__faqSchemaInjected) return;

    if (alreadyHasFaqSchema()) {
      window.__faqSchemaInjected = true;
      return;
    }

    const container = document.getElementById('faq-section');
    if (!container) return;

    const allDetails = container.querySelectorAll('details.faq-item');
    const faqs = [];
    const seen = new Set();

    function pushFaq(question, answer) {
      if (!question || !answer) return;

      const key = dedupKey(question);
      if (seen.has(key)) return;

      seen.add(key);

      faqs.push({
        '@type': 'Question',
        name: question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer
        }
      });
    }

    // Format A:
    // <details class="faq-item">
    //   <summary>Question</summary>
    //   <p>Answer</p>
    // </details>
    allDetails.forEach(item => {
      const summary = item.querySelector('summary');
      const question = getText(summary);

      if (!question) return;

      // Collect answer text.
      // Skip SUMMARY and heading elements to avoid mixing question text into the answer.
      const parts = [];

      Array.from(item.children).forEach(child => {
        const tag = child.tagName;

        if (tag === 'SUMMARY') return;
        if (/^H[1-6]$/.test(tag)) return;

        const txt = getText(child);
        if (txt) parts.push(txt);
      });

      pushFaq(question, parts.join(' ').trim());
    });

    // Format B:
    // <h3>Question</h3>
    // <p>Answer</p>
    // This does not require b or strong inside the h3.
    container.querySelectorAll('h3').forEach(h3 => {
      // Skip h3 elements inside details.faq-item because they are handled by Format A.
      if (h3.closest('details.faq-item')) return;

      const question = getText(h3);
      if (!question) return;

      const parts = [];
      let node = h3.nextElementSibling;

      while (node && node.tagName !== 'H3') {
        // Stop when another accordion item starts to avoid collecting unrelated content.
        if (node.matches && node.matches('details.faq-item')) break;

        const txt = getText(node);
        if (txt) parts.push(txt);

        node = node.nextElementSibling;
      }

      pushFaq(question, parts.join(' ').trim());
    });

    if (!faqs.length) return;

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs
    };

    const tag = document.createElement('script');
    tag.type = 'application/ld+json';
    tag.text = JSON.stringify(schema);

    document.head.appendChild(tag);

    window.__faqSchemaInjected = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Final cleanup: The 'load' event fires after all DOMContentLoaded listeners.
  // If duplicate FAQPage schemas are injected later, keep only the first instance and remove the rest.

  window.addEventListener('load', function () {
    const all = document.querySelectorAll('script[type="application/ld+json"]');
    let kept = false;
    all.forEach(s => {
      try {
        if (containsType(JSON.parse(s.textContent), 'FAQPage')) {
          if (kept) {
            s.remove();
          } else {
            kept = true;
          }
        }
      } catch (e) { /* ignore */ }
    });
  });
})();